import type { StoreLocatorPoint } from '../types/storeLocatorPoint'
import { useApolloClient } from '@vue/apollo-composable'
import getStoreLocatorPoints from '@/graphql/queries/getStoreLocatorPoints.graphql'

export default defineNuxtRouteMiddleware(async () => {
    const { resolveClient } = useApolloClient()
    const client = resolveClient()
    const getStoreLocatorPointsRequestPending = useState<boolean>('storeLocatorPointsRequestPending')
    const storeLocatorPoints = useState<StoreLocatorPoint[]>('storeLocatorPoints')

    getStoreLocatorPointsRequestPending.value = true

    const { data } = await client.query({
        query: getStoreLocatorPoints,
    })

    if (data.commonStockLocations) {
        getStoreLocatorPointsRequestPending.value = false

        storeLocatorPoints.value = data.commonStockLocations.filter((point) => {
            return point.latitude && point.longitude
        })
    } else {
        throw createError({
            statusCode: 404,
        })
    }
})
